import axios from 'axios'
import store from '@/store'
import { CRM_API_URL } from '@/constants/api'

function fetchFilialsStatistics (data) {
  const source = axios.CancelToken.source()
  const url = `${CRM_API_URL}/statistic/call-center/filials`
  store.dispatch('requests/addUniqueRequest', { url, source })

  return axios
    .post(url, data, { cancelToken: source.token })
    .then((response) => response.data)
}

function fetchFilialsIndicators (data) {
  const source = axios.CancelToken.source()
  const url = `${CRM_API_URL}/statistic/call-center/filials/indicators`
  store.dispatch('requests/addUniqueRequest', { url, source })

  return axios
    .post(url, data, { cancelToken: source.token })
    .then((response) => response.data)
}

function exportFilialsStatistics (data) {
  const source = axios.CancelToken.source()
  const url = `${CRM_API_URL}/statistic/call-center/filials/export`
  store.dispatch('requests/addUniqueRequest', { url, source })

  return axios.post(url, data, {
    responseType: 'blob',
    cancelToken: source.token,
  })
}

export default {
  fetchFilialsStatistics,
  fetchFilialsIndicators,
  exportFilialsStatistics,
}
